import { Routes, Route, Navigate } from "react-router-dom"
import Workspace from "../pages/Workspace";
import Form from "../pages/Form";
import SuccessEdit from "../pages/SuccessEdit";

const PrivateRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Navigate replace to="/workspace" />} />
            <Route path="/workspace" element={<Workspace />} />
            <Route path="/createform" element={<Form />} />
            <Route path="/editform" element={<Form />} />
            <Route path="/successEdit" element={<SuccessEdit />} />
        </Routes>
    );
}

export default PrivateRoutes